<!--Account Compromised Configuration popup-->
<popup-c class="no-content-padding bs-enabled" size="large"
	   head="Account Takeover Configuration Wizard"
	   (closeCb)="closePopup();">
	<div class="flex-column overflow-auto f-1-0 pt-2 gap-2" style="padding: 20px;">
		<!--steps progress-->
		<div class="steps-container" style="font-size: 0.8rem;">
			<div class="step-tab"
				 *ngFor="let cfgStep of dic.CONSTANTS.compromisedConfigurationSteps | keyvalue: gs.returnZero;"
				 [ngClass]="{'active' : step === cfgStep.value}">
				{{cfgStep.value}}
			</div>
		</div>

		<!--Steps content:-->
		<!--STEP: General information-->
		<div class="flex-column overflow-auto animated fadeIn f-1-0 gap-3 p-2 pt-3"
			 style="line-height: 1.5;"
			 *ngIf="step === dic.CONSTANTS.compromisedConfigurationSteps.generalInformation">
			<span class="diamond-indent position-relative ps-3">
				This wizard will guide you through configuring {{gs.corpname}}'s Account Takeover protection.
			</span>
            <div class="flex-column overflow-auto gap-3">
                <div class="flex-row justify-content-between gap-3 p-3" style="background: linear-gradient(90deg, hsla(var(--bs-primary-h),max(var(--bs-primary-s), 85%),max(var(--bs-primary-l), 79%), 0.31), white)">
                    <div class="position-relative" style="flex: 1 0;">
                        <i class="far fa-shield text-primary absolute-centralize opacity-75" style="font-size: 4rem; filter: drop-shadow(-2px 5px 0px #cccccc);"></i>
                    </div>
                    <div class="flex-column gap-2" style="flex: 2.5 0;">
                        <h6 class="text-primary m-0">How does the protection work?</h6>
                        <span>{{gs.corpname}} provides real-time protection against account takeovers by monitoring user activity for signs of suspicious behavior. When potential threats are detected, an alert notification will be sent right away.</span>
                    </div>
                </div>
                <div class="flex-row justify-content-between gap-3 p-3" style="background: linear-gradient(-90deg, hsla(var(--bs-primary-h),max(var(--bs-primary-s), 85%),max(var(--bs-primary-l), 79%), 0.31), white)">
                    <div class="position-relative" style="flex: 1 0;">
                        <i class="far fa-user-secret text-primary absolute-centralize opacity-75" style="font-size: 4rem; filter: drop-shadow(-2px 5px 0px #cccccc)"></i>
                    </div>
                    <div class="flex-column gap-2" style="flex: 2.5 0;">
                        <h6 class="text-primary m-0">Which incidents are monitored?</h6>
                        <div class="flex-row flex-wrap justify-content-start" style="row-gap: 10px; column-gap: 1.8%;">
                            <div class="flex-column centralize p-2 shadow-sm rounded-3 bg-white gap-1"
                                 style="flex-basis: calc(18%); line-height: 1.2;"
                                 *ngFor="let incidentType of configStages;">
                                <img [src]="'images/accountTakeoverIcons/' + incidentTypesInfo[incidentType.key].icon" style="height: 40px; min-height: 40px;">
                                <span class="text-center f-1-0" style="font-size: 11px;">{{incidentType.name}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex-row justify-content-between gap-3 p-3" style="background: linear-gradient(90deg, hsla(var(--bs-primary-h),max(var(--bs-primary-s), 85%),max(var(--bs-primary-l), 79%), 0.31), white)">
                    <div class="position-relative" style="flex: 1 0;">
                        <i class="far fa-list-ul text-primary absolute-centralize opacity-75" style="font-size: 4rem; filter: drop-shadow(-2px 5px 0px #cccccc)"></i>
                    </div>
                    <div class="flex-column gap-2" style="flex: 2.5 0;">
                        <h6 class="text-primary m-0">Set Immediate actions</h6>
                        <span>Configure Immediate automatic actions to be taken when incidents are detected. Determine which users to apply the actions to.</span>
                    </div>
                </div>
            </div>

			<div class="flex-column gap-2 f-1-0 justify-content-end">
                <hr class="mt-0 opacity-25"/>
                <span>In the next step, you will begin configuring each incident type individually.</span>
			</div>
		</div>

		<!--STEP: Configuration-->
		<div class="flxClmn f-1-0 animated fadeIn gap-3 p-2 pt-3 overflow-auto" *ngIf="step === dic.CONSTANTS.compromisedConfigurationSteps.configuration">
            <div class="dots-navigation-container" style="width: 90%; max-width: 400px; align-self: center;">
                <div class="navigation-dot d-flex centralize p-1" style="font-size: 16px; height: 25px; width: 25px;"
                     *ngFor="let incidentType of configStages; index as index;"
                     [ngClass]="{'active' : currentConfigStage === incidentType}"
                     (click)="isStepDataValid(currentConfigStage.key) && currentConfigStage = incidentType;"
                     [tooltip]="incidentType.name">
                    <b class="text-white">{{index + 1}}</b>
                </div>
            </div>

            <div class="flex-row justify-content-between align-items-center gap-4 mb-2" style="padding: 12px 12%; font-size: 14px; background: linear-gradient(45deg, #f9f9f9, #ffffff, #f9f9f9a6); box-shadow: 0 0 5px #f9f9f9; border: solid 1px #f8f8f8;">
                <div class="flex-column gap-2 align-self-stretch">
                    <h5 class="m-0 mt-2">{{currentConfigStage.name}}</h5>
                    <span>{{incidentTypesInfo[currentConfigStage.key].description}}</span>
                </div>
                <div class="px-4 py-1 shadow-sm rounded-3 bg-white">
                    <img [src]="'images/accountTakeoverIcons/' + incidentTypesInfo[currentConfigStage.key].icon" style="height: 100px; min-height: 100px; width: 100px; min-width: 100px;">
                </div>
            </div>
            <div class="list-group list-group-flush settings-list-container f-1-0">
                <div class="list-group-item settings-list-item f-1-0 py-2">
                    <div class="title-section-container flex-column gap-2" style="max-width: 28%;">
                        <b>Users to protect</b>
                        <span class="lh-base" style="font-size: 0.9em;">Select the users this protection will be applied to.</span>
                    </div>
                    <div class="content-container flex-column gap-2">
                        <div class="flex-column gap-2" *ngIf="currentConfigStage.name === dic.CONSTANTS.accountCompromisedIncidentTypes.high_recipient_compliant_rate.name || currentConfigStage.name === dic.CONSTANTS.accountCompromisedIncidentTypes.high_recipient_hard_bounce_rate.name">
                            <b>All users</b>
                            <span class="text-muted">This protection is applied by default to all users and cannot be changed or disabled</span>
                        </div>

                        <ng-container *ngIf="currentConfigStage.name !== dic.CONSTANTS.accountCompromisedIncidentTypes.high_recipient_compliant_rate.name && currentConfigStage.name !== dic.CONSTANTS.accountCompromisedIncidentTypes.high_recipient_hard_bounce_rate.name">
                            <ng-container *ngIf="currentConfigStage.name === dic.CONSTANTS.accountCompromisedIncidentTypes.new_forward_redirect_rules.name && (!this.exchangeServerConfig.enabled || !this.exchangeServerConfig.advanced_enabled)">
                                <div class="flxClmn f-1-0 gap-3">
                                    <span>To use this feature, please verify you have an active integration with the Exchange API and that advanced permissions have been granted.</span>

                                    <div class="flex-row align-items-center gap-2">
                                        <btn-c variant="outlined"
                                               [isDisabled]="verifyRulesStatus === 'in-process'"
                                               (action)="getUserEmailRules();">
                                            Verify access to mailboxes rules
                                        </btn-c>
                                        <div class="loading-spinner" style="position: relative; left: unset; top: unset; height: 20px; width: 20px; border-width: 3px;" *ngIf="verifyRulesStatus === 'in-process'"></div>
                                    </div>
                                    <div class="flex-column gap-3" *ngIf="verifyRulesStatus === 'failure'">
                                        <b class="text-danger" style="font-size: 14px;">Access to mailbox rules is not available.</b>
                                        <span class="ms-2">
                                            Make sure the following settings are enabled in the <a class="fw-bold blue-link" [routerLink]="['/' + dic.CONSTANTS.appStates.adminOutbound, dic.CONSTANTS.adminPages.outbound.sharedPlan, dic.CONSTANTS.outboundPlanSettingsPageTabs.integrations]" tooltip="Exchange Server Powershell">Integrations</a> page:
                                            <br/>
                                            - "Microsoft Exchange" integration is enabled and active.<br/>
                                            - "Advanced Permissions" have been granted.<br/>
                                            - The "Advanced Permissions" must be up to date. Click on the "Update Permissions" button in the "Microsoft Exchange Integration" window to verify.
                                        </span>
                                    </div>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="currentConfigStage.name !== dic.CONSTANTS.accountCompromisedIncidentTypes.new_forward_redirect_rules.name || (this.exchangeServerConfig.enabled && this.exchangeServerConfig.advanced_enabled)">
                                <label class="radio-container m-0" style="display: inline-block;">
                                    All users
                                    <input type="radio"
                                           [(ngModel)]="configData[currentConfigStage.key].selectUsersType"
                                           [value]="usersSelectionTypes.all"
                                           [checked]="configData[currentConfigStage.key].selectUsersType === usersSelectionTypes.all">
                                    <span class="checkmark"></span>
                                </label>
                                <div class="flex-row gap-1 align-items-center">
                                    <label class="radio-container m-0" style="display: block; width: fit-content;">
                                        Specific users:
                                        <input type="radio"
                                               [(ngModel)]="configData[currentConfigStage.key].selectUsersType"
                                               [value]="usersSelectionTypes.specific"
                                               [checked]="configData[currentConfigStage.key].selectUsersType === usersSelectionTypes.specific">
                                        <span class="checkmark"></span>
                                    </label>
                                    <span class="animated fadeIn" *ngIf="configData[currentConfigStage.key].selectUsersType === usersSelectionTypes.specific">
                                        ({{_.filter(configData[currentConfigStage.key].users, 'selected').length || '0'}} selected)
                                    </span>
                                </div>
                                <div class="position-relative f-1-0 flex-column overflow-auto">
                                    <!--table overlay when disabled-->
                                    <div class="w-100 h-100"
                                         style="background-color: white; position: absolute; top: 0; left: 0; z-index: 20; opacity: 0.6;"
                                         *ngIf="configData[currentConfigStage.key].selectUsersType === usersSelectionTypes.all">
                                    </div>
                                    <!--users table-->
                                    <trustifi-table-c
                                            #usersSelectTable
                                            class="trustifi-table" style="flex: 1 0; z-index: 5; min-height: 170px;"
                                            [list]="configData[currentConfigStage.key].users"
                                            [headers]="[
                                                {text:'Name', sortKey:'name'},
                                                {text:'Email', sortKey:'email'},
                                            ]"
                                            [cellsPrototype]="[
                                                {textKey: 'name'},
                                                {textKey: 'email'},
                                            ]"
                                            [options]="{
                                                itemsNameSingular: 'user',
                                                defaultSortKey: '-name',
                                                showRadioButtons: true
                                            }"
                                            (searchFunction)="searchUser($event)"
                                    >
                                        <!---->
                                    </trustifi-table-c>
                                </div>
                            </ng-container>
                        </ng-container>
                    </div>
                </div>

                <div class="list-group-item settings-list-item">
                    <div class="title-section-container flex-column gap-2" style="max-width: 28%;">
                        <b>Actions to perform</b>
                        <span class="lh-base" style="font-size: 0.9em;">Select the action to perform when such incident is detected.</span>
                    </div>
                    <div class="content-container flex-column gap-2">
                        <div class="flex-column justify-content-start flex-wrap" style="max-height: 85px;">
                            <checkbox class="p-1"
                                      *ngFor="let action of configData[currentConfigStage.key].actions | keyvalue"
                                      [(model)]="action.value.selected" [tooltipTxt]="action.value.tooltip">
                                {{action.value.display}}
                            </checkbox>
                        </div>
                    </div>
                </div>
            </div>


		</div>

		<!--STEP: Summary-->
		<div class="flxClmn f-1-0 animated fadeIn gap-5 p-2 pt-3" *ngIf="step === dic.CONSTANTS.compromisedConfigurationSteps.summary">
            <span style="font-size: 14px;">The following is the configuration you are about to apply. Please review it carefully before clicking on <b>"Configure"</b>.</span>
            <trustifi-table-c
                    class="trustifi-table" style="flex: 1 0;"
                    [list]="_.values(configData)"
                    [headers]="[
                        {text: 'Incident'},
                        {text: 'Users'},
                        {text: 'Actions'},
                    ]"
                    [cellsPrototype]="[
                        {textKey: 'name'},
                        {html: 'usersCell'},
                        {html: 'actionsCell'},
                    ]"
                    [options]="{
                        isEllipsis: false,
                        itemsNameSingular: 'incident',
                        hideCounter: true
                    }"
            >
                <ng-template #customCells let-item let-cellId="cellId">
                    <span *ngIf="cellId === 'usersCell'">
                        <b *ngIf="item.selectUsersType === usersSelectionTypes.all">All users</b>
                        <span *ngIf="item.selectUsersType === usersSelectionTypes.specific && _.filter(item.users, 'selected').length">
                            {{_.filter(item.users, 'selected').length > 1 ? (_.filter(item.users, 'selected').length + ' users') : _.filter(item.users, 'selected')[0].email}}
                        </span>
                        <span class="text-dark" *ngIf="item.selectUsersType === usersSelectionTypes.specific && !_.filter(item.users, 'selected').length">
                            No users
                        </span>
                    </span>

                    <span *ngIf="cellId === 'actionsCell'">
                        <div class="flex-column flex-wrap justify-content-start" style="max-height: 50px;">
                            <ng-container *ngFor="let action of item.actions | keyvalue">
                                  <span *ngIf="action.value.selected">{{action.value.display}}</span>
                            </ng-container>
                            <span *ngIf="!_.filter(item.actions, 'selected').length">Do nothing</span>
                        </div>
                    </span>
                </ng-template>
            </trustifi-table-c>
		</div>

		<!--error message and buttons-->
		<div class="flex-row justify-content-between align-items-end mb-3 px-4 w-100">
			<span class="f-1-0 pe-3 text-danger" style="min-height: 40px;">
				{{errorMsg || ' '}}
			</span>

			<div class="flex-row gap-3" style="font-size: 13px;">
                <btn-c class="popup-action-btn"
                       *ngIf="step === dic.CONSTANTS.compromisedConfigurationSteps.generalInformation"
                       variant="outlined"
                       (action)="closePopup();">
                    Cancel
                </btn-c>
                <btn-c class="popup-action-btn"
                       *ngIf="step !== dic.CONSTANTS.compromisedConfigurationSteps.generalInformation"
                       [isDisabled]="updateConfigInProcess"
                       variant="outlined"
                       (action)="backStep();">
                    Back
                </btn-c>
                <btn-c class="popup-action-btn"
                       *ngIf="step !== dic.CONSTANTS.compromisedConfigurationSteps.summary"
                       (action)="nextStep();">
                    Next
                </btn-c>
                <btn-c class="popup-action-btn"
                       *ngIf="step === dic.CONSTANTS.compromisedConfigurationSteps.summary"
                       [loading]="updateConfigInProcess"
                       (action)="updateAccountCompromisedConfig();">
                    Configure
                </btn-c>
			</div>
		</div>
	</div>
</popup-c>
